module.exports = __webpack_public_path__ + "h5/img/banner2.a30e908e.jpg";